/** Main project script */

// ensure the main object is defined
if (typeof(so) === 'undefined') {
    var so = {};
}

// main code
so.camdendcp = {
    init: function () {
        $('.no-ss[href]').each(function () {
            if ($(this).attr('href') != '') {
                var link = $(this).attr('href').split('#')[1];
                $(this).attr('href', '#'+link);
            }
        });
        $('[data-href]').addClass('jslink').on('click', function (e) {
            var target = $(this).data('href');
            window.location.href=target;
        });
        this.searchSanitiser();
        this.htmlEditorPatches();
        this.tooltips();
        this.initMenuToggle();
        this.collapseChevrons();
    },
    searchSanitiser: function () {
        $('input[name=Search]').each(function () {
            $(this).on('change', function () {
                var str = $(this).val();
                str = str.replace(/</g, "");
                str = str.replace(/>/g, "");
                $(this).val(str);
            })
        });
    },
    htmlEditorPatches: function () {
        $('.page-content table').wrap('<div class="table-responsive">');

        $('.captionImage img').each(function () {
            var src = $(this).attr('src');
            $(this).wrap('<a href="'+src+'" class="lightbox">');
        });

        $('.page-content a[href]').each(function () {
            $(this).addClass('link-checked');
            if ( $(this).attr('href').indexOf('.jpg') > 0) {
                $(this).addClass('lightbox').attr('rel', 'content-gallery');
            }
        });
        $('.lightbox').swipebox();

    },
    tooltips: function () {
        $('[data-toggle="tooltip"]')
            .tooltip({
                placement: "right",
                container: "body",
                boundary: "window",
                template: '<div class="tooltip d-none d-md-block" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
            }).on('shown.bs.tooltip', function () {
                var color = $(this).data('color');
                if (!color) {
                    color = 'tree-green';
                }
                $('.tooltip').eq(0).removeClass (function (index, className) {
                    return (className.match (/(^|\s)tooltip-color--\S+/g) || []).join(' ');
                }).addClass('tooltip-color-' + color);
            });
    },
    initMenuToggle: function () {
        $('#menutoggle').on('click', function () {
            $('#layout-container').toggleClass('menu-open');
        });
    },
    collapseChevrons: function () {
        $('.collapse').on('show.bs.collapse', function(e){
            if ($(this).is(e.target)) {
                var chevron = $(this).data("chevron");
                $('.'+chevron).removeClass("chevron-down").addClass("chevron-up");
            }
        }).on('hide.bs.collapse', function(e){
            if ($(this).is(e.target)) {
                var chevron = $(this).data("chevron");
                $('.'+chevron).removeClass("chevron-up").addClass("chevron-down");
            }
        });
    }


};

$(document).ready(function () {
    so.camdendcp.init();
});



// WEBPACK FOOTER //
// ./javascript/src/main.js